export const checkoutUrl = 'https://boxing-coach-ready.impultienda.ar/checkout'

export const productName = 'Boxing Coach Ready'

export const ctaLabel = 'GET BOXING COACH READY NOW'

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/558yFmPAoHBXpToKKb9P6m/Diseno_sin_titulo_(62).png'

export const price = {
  today: 'USD $27',
  value: 27,
}

export const comboIncludes = [
  '7 complete volumes',
  '150 ready-to-coach boxing sessions',
  'Session Finder',
  'Foundations & Core Mechanics',
  'Footwork, Defense & Counterpunching',
  'Combinations, Pad Work & Partner Drills',
  'Bag Work & Conditioning',
  'Tactics & Ringcraft',
  'Complete Session Vault',
  'Master Coaching Completion & Advanced Reference',
  'Regressions',
  'Progressions',
  'Coaching cues',
  'Corrections',
  'Tactical development',
  'Beginner-to-advanced adaptations',
  'Bonus 1 — 150 Boxing Drills',
  'Bonus 2 — 50 Boxing Games & Challenges',
  'Bonus 3 — 100 Mistakes & Corrections',
  'Bonus 4 — Kids, Teens & Adults Adaptation Guide',
  'Bonus 5 — 30 Emergency & No-Prep Sessions',
  'Instant digital access',
  'Ready-to-use PDF resources',
  '7-day money-back guarantee',
]

export const finalIncludes = [
  '7 complete professional volumes',
  '150 ready-to-coach sessions',
  'Session Finder',
  'Boxing foundations',
  'Punch mechanics',
  'Footwork',
  'Range',
  'Defense',
  'Counterpunching',
  'Combinations',
  'Pad work',
  'Partner work',
  'Bag work',
  'Conditioning',
  'Tactics',
  'Ringcraft',
  'Boxer development',
  'Intermediate progressions',
  'Advanced progressions',
  'Coaching diagnostics',
  'Error-to-correction systems',
  'Coach cue library',
  '150 bonus boxing drills',
  '50 boxing games and challenges',
  '100 mistakes and corrections',
  'Kids, Teens & Adults Coaching Adaptation Guide',
  '30 Emergency & No-Prep Sessions',
  'Boxing-specific safety guidance',
  'Instant access',
  'PDF format',
  '7-day guarantee',
]

export function trackCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'Boxing Coach Ready',
    value: price.value,
    currency: 'USD',
  })
}
